import { Shield, Award, Scale } from "lucide-react";

export const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center noise-bg overflow-hidden" data-testid="hero-section">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-[#FAFAF9]/85 via-[#FAFAF9]/60 to-[#FAFAF9]/20 z-10" />
        <img
          src="https://images.unsplash.com/photo-1650389822497-0f37cc12aaa0?auto=format&fit=crop&w=2000&q=80"
          alt="Philadelphia Skyline"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-3xl">
          {/* Attorney Badge */}
          <div className="inline-flex items-center gap-3 bg-[#0F172A] text-white px-5 py-2.5 mb-8 animate-fade-in" data-testid="attorney-badge">
            <Scale className="w-4 h-4 text-[#B45309]" strokeWidth={1.5} />
            <span className="text-xs font-bold uppercase tracking-widest">Attorney-Led Title Services</span>
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-medium text-[#0F172A] tracking-tight leading-[1.1] mb-6 animate-fade-in-delay-1 drop-shadow-sm" data-testid="hero-headline">
            The Closing Your Clients Will Remember
          </h1>

          {/* Subheadline */}
          <p className="text-lg md:text-xl text-[#374151] leading-relaxed mb-10 max-w-2xl animate-fade-in-delay-2 drop-shadow-sm" data-testid="hero-subheadline">
            For 30 years, we've partnered with top-producing realtors, loan officers, and attorneys 
            across Pennsylvania, New Jersey, New York, and Florida. Our attorney-led approach means 
            problems are solved before they become surprises.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fade-in-delay-3">
            <a
              href="#contact"
              className="inline-flex items-center justify-center bg-[#0F172A] text-white px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#1e293b] btn-transition"
              data-testid="hero-cta-primary"
            >
              Request a Quote
            </a>
            <a
              href="#why-us"
              className="inline-flex items-center justify-center border border-[#0F172A] text-[#0F172A] px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-[#0F172A] hover:text-white btn-transition"
              data-testid="hero-cta-secondary"
            >
              Why Choose Us
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-10 mt-16 pt-8 border-t border-[#E7E5E4]">
            <div className="flex items-center gap-3">
              <Award className="w-6 h-6 text-[#B45309]" strokeWidth={2} />
              <span className="text-base font-semibold text-[#0F172A]">30+ Years Experience</span>
            </div>
            <div className="flex items-center gap-3">
              <Shield className="w-6 h-6 text-[#B45309]" strokeWidth={2} />
              <span className="text-base font-semibold text-[#0F172A]">4-State Licensed</span>
            </div>
            <div className="flex items-center gap-3">
              <Scale className="w-6 h-6 text-[#B45309]" strokeWidth={2} />
              <span className="text-base font-semibold text-[#0F172A]">Attorney Oversight</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
